module.exports = __webpack_public_path__ + "img/pressure_gray.226bf9ef.svg";